import type { SVGProps } from "react";
export interface Arrow04UpIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Arrow04UpIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Arrow04UpIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14.38 11.5c0-.621.504-1.125 1.125-1.125h3.543L12.93 3.93a13 13 0 0 0-.66-.67 1 1 0 0 0-.137-.11l-.009-.007a.38.38 0 0 0-.24 0c.028-.01-.004-.01-.147.117-.152.136-.342.337-.659.67L4.96 10.375h3.544c.621 0 1.125.504 1.125 1.125v8.1c0 .438 0 .7.016.893.009.107.02.159.025.177.036.07.093.128.164.164-.024-.012-.004.009.176.024.194.015.456.017.895.017h2.2c.439 0 .701-.002.895-.017.18-.015.2-.036.176-.024a.38.38 0 0 0 .164-.164c.005-.018.016-.07.025-.177.015-.194.016-.455.016-.892v-8.1Zm2.25 8.1c0 .402.002.771-.024 1.077a2.7 2.7 0 0 1-.262 1.015 2.63 2.63 0 0 1-1.147 1.148c-.345.175-.695.234-1.015.26-.306.025-.676.025-1.078.025h-2.2c-.402 0-.772 0-1.078-.025-.32-.026-.67-.085-1.015-.26a2.63 2.63 0 0 1-1.147-1.148 2.7 2.7 0 0 1-.263-1.015c-.025-.306-.023-.675-.023-1.076v-6.976H4.202c-.271 0-.552.001-.778-.019-.193-.017-.61-.064-.965-.362a1.63 1.63 0 0 1-.577-1.341l.02-.168c.07-.376.277-.65.383-.783.14-.178.335-.38.521-.577l6.64-6.995c.29-.306.555-.585.794-.798.248-.222.545-.442.926-.57a2.63 2.63 0 0 1 1.676 0c.381.128.677.348.926.57.239.213.503.492.793.798l6.64 6.995c.187.196.381.399.522.577.106.133.314.407.383.784l.02.166v.192a1.63 1.63 0 0 1-.577 1.15c-.354.298-.772.345-.965.362-.227.02-.507.02-.778.02H16.63z"
      />
    </svg>
  );
}
